export default __webpack_public_path__ + "static/Best-Countries-for-Shopaholics-Tokyo-Japan-d7e699b3f4d232623981dbd923753259.jpg";